import React from 'react'
import { Text, TextProps } from '@nominex/dex-uikit'
import getTimePeriods from 'utils/getTimePeriods'
import { useTranslation } from 'contexts/Localization'

const leadingZero = (number) => `${number > 9 ? '' : '0'}${number}`

const formattedTime = (days, hours, minutes, seconds) =>
  `${days ? `${days}:` : ''}${leadingZero(hours)}:${leadingZero(minutes)}:${leadingZero(seconds)}`

const Timer: React.FC<TextProps & { secondsRemaining: number; digitsOnly?: boolean }> = ({
  digitsOnly = false,
  fontSize = '11px',
  secondsRemaining,
  ...props
}) => {
  const { t } = useTranslation()
  const { days, hours, minutes, seconds } = getTimePeriods(secondsRemaining)

  return (
    <Text fontSize={fontSize} tnum {...props}>
      {!digitsOnly && t('⏱ in ')}
      {formattedTime(days, hours, minutes, seconds)}
    </Text>
  )
}

export default Timer
